<template>
    <v-container grid-list-md class="form-home">
        <div class="row">
            <div class='col-sm-12'>
                <div class="row">
                    <div class="col-sm-12">
                        <h3 class="text-color mb-3">LIÊN HỆ TẠO SITE RIÊNG CHO ĐẠI LÝ</h3>
                        <v-card dark :color="COLOR.MAIN_COLOR" class="">
                            <div class="col-sm-12 mt-1">
                                <div class="float-left">
                                    <i class="mdi mdi-checkbox-multiple-marked-outline" style="font-size: larger"></i>
                                </div>
                                <div class="mt-1 ml-3">
                                    <a class="white--text ml-2" style="cursor: auto">{{support.mobile.text}} (Zalo/SMS/Call)</a>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="float-left">
                                    <i class="mdi mdi-checkbox-multiple-marked-outline" style="font-size: larger"></i>
                                </div>
                                <div class="mt-1 ml-3">
                                    <a class="ml-2 a-suport" :href="support.group.link" target="_blank">{{
                                        support.group.text }}</a>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="float-left">
                                    <i class="mdi mdi-checkbox-multiple-marked-outline" style="font-size: larger"></i>
                                </div>
                                <div class="mt-1 ml-3">
                                    <a class="ml-2 a-suport" :href="support.fanpage.link" target="_blank">{{
                                        support.fanpage.text }}</a>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="float-left">
                                    <i class="mdi mdi-checkbox-multiple-marked-outline" style="font-size: larger"></i>
                                </div>
                                <div class="mt-1 ml-3">
                                    <a class="ml-2 a-suport" :href="support.tele.link" target="_blank">{{
                                        support.tele.text }}</a>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="float-left">
                                    <i class="mdi mdi-checkbox-multiple-marked-outline" style="font-size: larger"></i>
                                </div>
                                <div class="mt-1 ml-3">
                                    <a class="ml-2 a-suport" :href="support.tele_channel.link" target="_blank">{{
                                        support.tele_channel.text }}</a>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
  import Vue from 'vue'
  import 'vue2-datepicker/index.css';
  import {COLOR} from "~/config/constant";
  import $ from 'jquery';
  import VueYoutube from 'vue-youtube';
  import {CONFIG_PAGE} from "~/store/actions.type";

  Vue.use(VueYoutube);
  export default {
    components: {
    },
    data() {
      return {
        // Color chinh
        COLOR: COLOR,
        loaded: false,
        videoId: 'V7smeN8hAOw',
        videoStatus: true,
        pageSize: 10,
        support: {
          group: {
            src: '/images/suport/group.jpg',
            link: 'https://bit.ly/amaisupport',
            text: 'Group'
          },
          fanpage: {
            src: '/images/suport/group.jpeg',
            link: 'https://bit.ly/AmaiAgency',
            text: 'Fanpage',
            messenger: 'https://www.facebook.com/messages/t/amaiagency'
          },
          tele: {
            src: '/images/suport/group.jpeg',
            link: 'https://t.me/amaihotrodaily',
            text: 'Telegram'
          },
          tele_channel: {
            src: '/images/suport/group.jpeg',
            link: 'https://t.me/amaisupport',
            text: 'Telegram Channel'
          },
          zalo: {
            src: '/images/suport/group.jpeg',
            link: 'https://bit.ly/AmaiSupportZalo',
            text: 'Zalo'
          },
          mobile: {
            src: '/images/phone.png',
            link: '',
            text: '0812361221'
          },
          top_url: {
            src: '',
            link: '',
            text: ''
          },
        },
        visible: 0
      }
    },
    created() {
    },
    computed: {
      player() {
        return this.$refs.youtube.player
      }
    },
    mounted() {
      if (window.innerWidth <= 1263) {
        setTimeout(function () {
          $(".v-overlay").css('z-index', 'unset');
        }, 0);
      }
      this.configPage();
    },
    methods: {
      playing() {
        this.videoStatus = false;
      },
      paused() {
        this.videoStatus = true;
      },
      configPage() {
        this.$store.dispatch(CONFIG_PAGE).then((data) => {
          let group = data.filter(o => o.key == 'key_cp_group');
          if (group[0]['value'] != undefined && group[0]['value'] != '' && group[0]['status']) {
            this.support.group.link = group[0]['value'];
          }

          let fanpage = data.filter(o => o.key == 'key_cp_fanpage');
          if (fanpage[0]['value'] != undefined && fanpage[0]['value'] != '' && fanpage[0]['status']) {
            this.support.fanpage.link = fanpage[0]['value'];
          }

          let tele = data.filter(o => o.key == 'key_cp_telegram');
          if (tele[0]['value'] != undefined && tele[0]['value'] != '' && tele[0]['status']) {
            this.support.tele.link = tele[0]['value'];
          }

          let tele_channel = data.filter(o => o.key == 'key_cp_telegram_channel');
          if (tele_channel[0]['value'] != undefined && tele_channel[0]['value'] != '' && tele_channel[0]['status']) {
            this.support.tele_channel.link = tele_channel[0]['value'];
          }

          let zalo = data.filter(o => o.key == 'key_cp_zalo');
          if (zalo[0]['value'] != undefined && zalo[0]['value'] != '' && zalo[0]['status']) {
            this.support.zalo.link = zalo[0]['value'];
          }

          let mobile = data.filter(o => o.key == 'key_cp_hotline');
          if (mobile[0]['value'] != undefined && mobile[0]['value'] != '' && mobile[0]['status']) {
            this.support.mobile.text = mobile[0]['value'];
          }

          let youtube = data.filter(o => o.key == 'key_cp_youtube');
          if (youtube[0]['value'] != undefined && youtube[0]['value'] != '') {
            this.visible = youtube[0]['status'];
          }
          if (youtube[0]['value'] != undefined && youtube[0]['value'] != '' && youtube[0]['status']) {
            let videoId = this.youtube_parser(youtube[0]['value']);
            if (videoId) {
              this.videoId = videoId;
            }
          }
          let top_url = data.filter(o => o.key == 'key_cp_top_url');
          if (top_url[0]['value'] != undefined && top_url[0]['value'] != '' && top_url[0]['status']) {
            this.support.top_url.link = top_url[0]['value'];
          }
        });
      },
      youtube_parser(url) {
        let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        let match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
      }
    },
  };
</script>
<style lang="scss">
    @import "../../scss/main";

    .text-color {
        color: $mainColor;
        font-weight: bold;
    }
</style>
